<!-- @format -->

@if (items()) {
	<div
		id="pdp-highlights"
		class="hmf-mx-0 hmf-px-xs hmf-py-s hmf-mb-s hmf-mb-md-l">
		<div class="hmf-body-bold-l hmf-header-bold-md-s">
			Highlights
		</div>
		<ul class="hmf-mt-xs hmf-ml-xxxs hmf-pl-xs hmf-mb-0">
			@for (item of items(); track trackByFn($index, item)) {
				<li
					class="hmf-body-m hmf-pt-xxxs label-base">
					{{ item }}
				</li>
			}
		</ul>
	</div>
}
